<script>
export default {
  name: "HeaderPage",
  data: function () {
    return {
      username: this.$store.getters["user/userData"]?.username,
    };
  },
  methods: {
    handleLogout() {
      console.log("点击了退出登录按钮");
      alert("点击了退出登录");

      // 直接清除本地数据并跳转
      this.$store.dispatch("user/logout");
      this.$router.push("/admin/login");

      this.$message({
        message: "退出登录成功",
        type: "success",
      });
    },
  },
};
</script>

<template>
  <el-row>
    <el-col :span="12"><div class="grid-content bg-purple"></div></el-col>
    <el-col :span="12">
      <div class="grid-content bg-purple-light">
        <span class="username">{{ this.username }}</span>
        <el-button type="danger" size="small" @click="handleLogout" plain
          >退出登录</el-button
        >
      </div>
    </el-col>
  </el-row>
</template>

<style scoped>
.bg-purple {
  background: #c8b6a2;
}
.bg-purple-light {
  background: #c8b6a2;
  text-align: right;
  padding-right: 25px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.grid-content {
  height: 40px;
}
.username {
  margin-right: 15px;
  font-size: 14px;
}
</style>
